import { TFormalOffers } from './formalOffers.types';
import { getDurationInMonths } from '../GetDurationInMonths/getDurationInMonths';

export const getSortedFormalOffersByDurationDescending = (
    formalOffers: TFormalOffers
) =>
    [...formalOffers].sort(
        (a, b) =>
            getDurationInMonths(b.duration!) - getDurationInMonths(a.duration!)
    );
